<template>
	<!-- 	<div style="position: relative;">
		<div id="mapDiv" class="map_layout" ></div>
	</div> -->

	<!-- 	<div class="page6_main_layout_phone">
			<div class="page7_main_img_1" >
			</div>

			<div class="main_map_layout">

				<div style="">

					<div class="page6_about_content_layout">
						<div style="width: 100%;height: 40px;line-height: 40px;font-size: 24px;text-align: left;margin-left: 30px;
						margin-top: 40px;">
							联系方式
						</div>
						<div style="width: 50px;height: 3px;line-height: 40px;font-size: 24px;text-align: left;margin-left: 30px;
						margin-top: 10px;background-color: #B72024;"></div>
						
						<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 20px;">
							联系电话：15927666885
						</div>
						<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 0px;">
							公司邮箱：sales@doeasyai.com
						</div>
						<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 0px;">
							公司网站：www.doeasyit.com
						</div>
						<div style="width: 100%;height: 40px;line-height: 40px;font-size: 17px;text-align: left;margin-left: 30px;
						margin-top: 0px;">
							联系地址：武汉市洪山区关东科技工业园
						</div>
					</div>
					
				</div>

	
			</div>
			
	
	</div> -->

	<div class="page7_main_layout">
		<div class="page7_main_img_1">
			<!-- 			<div style="
					font-size: 60px;
					color: #ffffff;
					font-weight: 600;
					margin-top: 10px;
					
				"
			>
				颠覆想象，视觉设备新革命：为千行百业注入无限可能
			</div> -->
			<div class="page7_main_img_text_1">
				行业应用
			</div>
			<div class="page7_main_img_text_2">
				Industry Applications
			</div>
		</div>
		<div class="page7_main_menu_layout">
			<div class="page7_main_menu_list">
				<div class="page7_main_menu_item" v-for="(item, key) in product_list_data_4" :key="key"
					@click="choose_menu_item(key)"
					:style="now_show_item_index == key ? 'color: #00ffff;background-color: rgba(50, 215, 215, 0.1);' : ''">
					<!--	:style="now_show_item_index==key?'color: #d81e06;background-color: rgba(216, 30, 6, 0.1);':''" -->

					{{ item.title }}
				</div>
			</div>
		</div>
		<div class="page7_main_content_layout_phone">
			<div class="page7_main_content_title_phone">
				{{ now_show_item_data.title }}
			</div>
			<div class="page7_main_content_value_phone">
				{{ now_show_item_data.content }}
			</div>
			<div class="page7_main_content_img page7_main_content_img_0" v-show="now_show_item_index == 0"></div>
			<div class="page7_main_content_img page7_main_content_img_1" v-show="now_show_item_index == 1"></div>
			<div class="page7_main_content_img page7_main_content_img_2" v-show="now_show_item_index == 2"></div>
			<div class="page7_main_content_img page7_main_content_img_3" v-show="now_show_item_index == 3"></div>
			<div class="page7_main_content_img page7_main_content_img_4" v-show="now_show_item_index == 4"></div>
			<div class="page7_main_content_img page7_main_content_img_5" v-show="now_show_item_index == 5"></div>
			<div class="page7_main_content_img page7_main_content_img_6" v-show="now_show_item_index == 6"></div>

		</div>


		<div class="page7_main_content_layout">
			<div class="page7_main_content_title">
				{{ now_show_item_data.title }}
			</div>
			<div class="page7_main_content_value">
				{{ now_show_item_data.content }}
			</div>
			<div class="page7_main_content_img page7_main_content_img_0" v-show="now_show_item_index == 0"></div>
			<div class="page7_main_content_img page7_main_content_img_1" v-show="now_show_item_index == 1"></div>
			<div class="page7_main_content_img page7_main_content_img_2" v-show="now_show_item_index == 2"></div>
			<div class="page7_main_content_img page7_main_content_img_3" v-show="now_show_item_index == 3"></div>
			<div class="page7_main_content_img page7_main_content_img_4" v-show="now_show_item_index == 4"></div>
			<div class="page7_main_content_img page7_main_content_img_5" v-show="now_show_item_index == 5"></div>
			<div class="page7_main_content_img page7_main_content_img_6" v-show="now_show_item_index == 6"></div>

		</div>

		<div class="page7_main_show_list_layout_phone">
			<div class="page7_main_show_item" v-for="(value, key, index) in now_show_item_data.show_list" :key="key"
				:style="(key + 1) % 5 == 0 ? 'margin-right: 0px;' : 'margin-right: 0px;'" @click="choose_one_item(key)">
				<div class="page7_main_show_item_title">
					{{ value.title }}
				</div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_0"
					v-show="now_show_item_index == 0 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_1"
					v-show="now_show_item_index == 0 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_2"
					v-show="now_show_item_index == 0 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_3"
					v-show="now_show_item_index == 0 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_4"
					v-show="now_show_item_index == 0 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_5"
					v-show="now_show_item_index == 0 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_6"
					v-show="now_show_item_index == 0 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_7"
					v-show="now_show_item_index == 0 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_8"
					v-show="now_show_item_index == 0 && key == 8"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_9"
					v-show="now_show_item_index == 0 && key == 9"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_10"
					v-show="now_show_item_index == 0 && key == 10"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_1_0"
					v-show="now_show_item_index == 1 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_1"
					v-show="now_show_item_index == 1 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_2"
					v-show="now_show_item_index == 1 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_3"
					v-show="now_show_item_index == 1 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_4"
					v-show="now_show_item_index == 1 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_5"
					v-show="now_show_item_index == 1 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_6"
					v-show="now_show_item_index == 1 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_7"
					v-show="now_show_item_index == 1 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_8"
					v-show="now_show_item_index == 1 && key == 8"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_9"
					v-show="now_show_item_index == 1 && key == 9"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_10"
					v-show="now_show_item_index == 1 && key == 10"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_11"
					v-show="now_show_item_index == 1 && key == 11"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_12"
					v-show="now_show_item_index == 1 && key == 12"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_13"
					v-show="now_show_item_index == 1 && key == 13"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_14"
					v-show="now_show_item_index == 1 && key == 14"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_15"
					v-show="now_show_item_index == 1 && key == 15"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_16"
					v-show="now_show_item_index == 1 && key == 16"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_2_0"
					v-show="now_show_item_index == 2 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_1"
					v-show="now_show_item_index == 2 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_2"
					v-show="now_show_item_index == 2 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_3"
					v-show="now_show_item_index == 2 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_4"
					v-show="now_show_item_index == 2 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_5"
					v-show="now_show_item_index == 2 && key == 5"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_3_0"
					v-show="now_show_item_index == 3 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_1"
					v-show="now_show_item_index == 3 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_2"
					v-show="now_show_item_index == 3 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_3"
					v-show="now_show_item_index == 3 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_4"
					v-show="now_show_item_index == 3 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_5"
					v-show="now_show_item_index == 3 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_6"
					v-show="now_show_item_index == 3 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_7"
					v-show="now_show_item_index == 3 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_8"
					v-show="now_show_item_index == 3 && key == 8"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_4_0"
					v-show="now_show_item_index == 4 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_1"
					v-show="now_show_item_index == 4 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_2"
					v-show="now_show_item_index == 4 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_3"
					v-show="now_show_item_index == 4 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_4"
					v-show="now_show_item_index == 4 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_5"
					v-show="now_show_item_index == 4 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_6"
					v-show="now_show_item_index == 4 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_7"
					v-show="now_show_item_index == 4 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_8"
					v-show="now_show_item_index == 4 && key == 8"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_9"
					v-show="now_show_item_index == 4 && key == 9"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_10"
					v-show="now_show_item_index == 4 && key == 10"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_11"
					v-show="now_show_item_index == 4 && key == 11"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_12"
					v-show="now_show_item_index == 4 && key == 12"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_13"
					v-show="now_show_item_index == 4 && key == 13"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_14"
					v-show="now_show_item_index == 4 && key == 14"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_15"
					v-show="now_show_item_index == 4 && key == 15"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_5_0"
					v-show="now_show_item_index == 5 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_1"
					v-show="now_show_item_index == 5 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_2"
					v-show="now_show_item_index == 5 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_3"
					v-show="now_show_item_index == 5 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_4"
					v-show="now_show_item_index == 5 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_5"
					v-show="now_show_item_index == 5 && key == 5"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_6_0"
					v-show="now_show_item_index == 6 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_1"
					v-show="now_show_item_index == 6 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_2"
					v-show="now_show_item_index == 6 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_3"
					v-show="now_show_item_index == 6 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_4"
					v-show="now_show_item_index == 6 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_5"
					v-show="now_show_item_index == 6 && key == 5"></div>


			</div>
		</div>

		<div class="page7_main_show_list_layout">
			<div class="page7_main_show_item" v-for="(value, key, index) in now_show_item_data.show_list" :key="key"
				:style="(key + 1) % 5 == 0 ? 'margin-right: 0px;' : 'margin-right: 25px;'"
				@click="choose_one_item(key)">
				<div class="page7_main_show_item_title">
					{{ value.title }}
				</div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_0"
					v-show="now_show_item_index == 0 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_1"
					v-show="now_show_item_index == 0 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_2"
					v-show="now_show_item_index == 0 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_3"
					v-show="now_show_item_index == 0 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_4"
					v-show="now_show_item_index == 0 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_5"
					v-show="now_show_item_index == 0 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_6"
					v-show="now_show_item_index == 0 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_7"
					v-show="now_show_item_index == 0 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_8"
					v-show="now_show_item_index == 0 && key == 8"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_9"
					v-show="now_show_item_index == 0 && key == 9"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_0_10"
					v-show="now_show_item_index == 0 && key == 10"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_1_0"
					v-show="now_show_item_index == 1 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_1"
					v-show="now_show_item_index == 1 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_2"
					v-show="now_show_item_index == 1 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_3"
					v-show="now_show_item_index == 1 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_4"
					v-show="now_show_item_index == 1 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_5"
					v-show="now_show_item_index == 1 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_6"
					v-show="now_show_item_index == 1 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_7"
					v-show="now_show_item_index == 1 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_8"
					v-show="now_show_item_index == 1 && key == 8"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_9"
					v-show="now_show_item_index == 1 && key == 9"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_10"
					v-show="now_show_item_index == 1 && key == 10"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_11"
					v-show="now_show_item_index == 1 && key == 11"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_12"
					v-show="now_show_item_index == 1 && key == 12"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_13"
					v-show="now_show_item_index == 1 && key == 13"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_14"
					v-show="now_show_item_index == 1 && key == 14"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_15"
					v-show="now_show_item_index == 1 && key == 15"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_1_16"
					v-show="now_show_item_index == 1 && key == 16"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_2_0"
					v-show="now_show_item_index == 2 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_1"
					v-show="now_show_item_index == 2 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_2"
					v-show="now_show_item_index == 2 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_3"
					v-show="now_show_item_index == 2 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_4"
					v-show="now_show_item_index == 2 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_2_5"
					v-show="now_show_item_index == 2 && key == 5"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_3_0"
					v-show="now_show_item_index == 3 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_1"
					v-show="now_show_item_index == 3 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_2"
					v-show="now_show_item_index == 3 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_3"
					v-show="now_show_item_index == 3 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_4"
					v-show="now_show_item_index == 3 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_5"
					v-show="now_show_item_index == 3 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_6"
					v-show="now_show_item_index == 3 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_7"
					v-show="now_show_item_index == 3 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_3_8"
					v-show="now_show_item_index == 3 && key == 8"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_4_0"
					v-show="now_show_item_index == 4 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_1"
					v-show="now_show_item_index == 4 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_2"
					v-show="now_show_item_index == 4 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_3"
					v-show="now_show_item_index == 4 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_4"
					v-show="now_show_item_index == 4 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_5"
					v-show="now_show_item_index == 4 && key == 5"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_6"
					v-show="now_show_item_index == 4 && key == 6"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_7"
					v-show="now_show_item_index == 4 && key == 7"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_8"
					v-show="now_show_item_index == 4 && key == 8"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_9"
					v-show="now_show_item_index == 4 && key == 9"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_10"
					v-show="now_show_item_index == 4 && key == 10"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_11"
					v-show="now_show_item_index == 4 && key == 11"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_12"
					v-show="now_show_item_index == 4 && key == 12"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_13"
					v-show="now_show_item_index == 4 && key == 13"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_14"
					v-show="now_show_item_index == 4 && key == 14"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_4_15"
					v-show="now_show_item_index == 4 && key == 15"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_5_0"
					v-show="now_show_item_index == 5 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_1"
					v-show="now_show_item_index == 5 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_2"
					v-show="now_show_item_index == 5 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_3"
					v-show="now_show_item_index == 5 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_4"
					v-show="now_show_item_index == 5 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_5_5"
					v-show="now_show_item_index == 5 && key == 5"></div>

				<div class="page7_main_show_item_img page7_main_show_item_img_6_0"
					v-show="now_show_item_index == 6 && key == 0"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_1"
					v-show="now_show_item_index == 6 && key == 1"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_2"
					v-show="now_show_item_index == 6 && key == 2"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_3"
					v-show="now_show_item_index == 6 && key == 3"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_4"
					v-show="now_show_item_index == 6 && key == 4"></div>
				<div class="page7_main_show_item_img page7_main_show_item_img_6_5"
					v-show="now_show_item_index == 6 && key == 5"></div>


			</div>
		</div>
	</div>
	<Footer></Footer>

</template>

<script>
import request from "@/utils/request";
import Footer from '@/components/Footer'

export default {
	name: "page6",
	components: {
		Footer
	},
	data() {
		return {
			map_obj: "",
			product_list_data_4: [],
			now_show_item_index: 0,
			now_show_item_data: {},

		}
	},
	mounted() {
		this.product_list_data_4 = this.$GLOBAL.product_list_data_4
		// console.log(this.now_show_item_data)

		let ap_sub = window.localStorage.getItem("ap_sub")
		if (ap_sub) {
			this.now_show_item_index = ap_sub
		}

		this.now_show_item_data = this.product_list_data_4[this.now_show_item_index]

		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0

		// console.log(this.product_list_data_4)
		// this.init_map()

		this.$GLOBAL.methods.init_header_menu("page7")


	},
	methods: {

		choose_one_item(item_index) {
			window.localStorage.setItem("ap_sub", this.now_show_item_index)
			window.localStorage.setItem("ap_sub_item", item_index)
			this.$router.push("/main/application_case")
		},
		choose_menu_item(index) {
			this.now_show_item_index = index
			this.now_show_item_data = this.product_list_data_4[index]
		},
		init_map() {
			this.map_obj = new T.Map('mapDiv');
			var latlng = new T.LngLat(114.4262, 30.50548);
			this.map_obj.centerAndZoom(latlng, 12);
			document.getElementsByClassName("tdt-control-copyright tdt-control")[0].style.display = 'none'
			//创建标注对象
			var marker = new T.Marker(new T.LngLat(114.4262, 30.50548));
			//向地图上添加标注
			this.map_obj.addOverLay(marker);
			var label = new T.Label({
				text: "",
				text: `<div style="
							line-height: 28px;
							font-size: 20px;
							width: 340px;
							height:60px;
							font-family: "楷体","楷体_GB2312";
						">
						<span style="">武汉市洪山区关东科技工业园1栋3楼</span>
						<br/>
						<span style="color: #1296db;font-weight: 600;">武汉为之易科技有限公司</span>
					</div>`,
				position: latlng,
				offset: new T.Point(-188, -80)
			});
			//创建地图文本对象
			this.map_obj.addOverLay(label);
			this.map_obj.setMinZoom(10);
			this.map_obj.setMaxZoom(18);

		},

	},

}
</script>

<style></style>